import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { LoaderComponent } from '../loader/loader.component';
import { PaginationComponent } from '../pagination/pagination.component';
import { BasePagedTableComponent } from '../../../core/layout/components/abstracts/base-paged-table.component';
import { TranslatePipe } from '../../pipes/trans.pipe';

@Component({
  selector: 'app-paged-table',
  standalone: true,
  imports: [
    LoaderComponent,
    PaginationComponent,
    TranslatePipe,
  ],
  templateUrl: './paged-table.component.html',
  styleUrl: './paged-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PagedTableComponent<T> extends BaseComponent {

  @Input() isCustomTable = false;
  @Input({ required: true }) mode: 'base' | 'base-2';

  public basePagedTableComponent: BasePagedTableComponent<T>;
}
